// extracted by mini-css-extract-plugin
export default {"primary":"#e8eae2","secondary":"#e8eae2"};